import React from 'react'

import './index.scss'

export const ListViewIcon = () => {
  return (
    <svg
      className="icon icon--list-view"
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 10H16M4 14H16M4 6H16"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
